import 'react/jsx-runtime';
import { IconCheck } from '../../svg/icons/icon-check.js';
import { IconInfo } from '../../svg/icons/icon-info.js';
import { IconWarningTriangle } from '../../svg/icons/icon-warning-triangle.js';
import { IconWarning } from '../../svg/icons/icon-warning.js';

var ToastType;
(function (ToastType) {
    ToastType["SUCCESS"] = "SUCCESS";
    ToastType["INFO"] = "INFO";
    ToastType["WARNING"] = "WARNING";
    ToastType["ERROR"] = "ERROR";
})(ToastType || (ToastType = {}));
const TOAST_TYPE_TO_COLOR_AND_SVG = {
    [ToastType.SUCCESS]: [
        'border-leland-primary',
        'bg-leland-primary',
        IconCheck,
    ],
    [ToastType.INFO]: [
        'border-leland-dark-green',
        'bg-leland-dark-green',
        IconInfo,
    ],
    [ToastType.WARNING]: [
        'border-leland-orange',
        'bg-leland-orange',
        IconWarning,
    ],
    [ToastType.ERROR]: [
        'border-leland-red',
        'bg-leland-red',
        IconWarningTriangle,
    ],
};
var ToastDuration;
(function (ToastDuration) {
    ToastDuration["SHORT"] = "SHORT";
    ToastDuration["NORMAL"] = "NORMAL";
    ToastDuration["LONG"] = "LONG";
    ToastDuration["FOREVER"] = "FOREVER";
})(ToastDuration || (ToastDuration = {}));
const TOAST_DURATION_TO_MS = {
    [ToastDuration.SHORT]: 2500,
    [ToastDuration.NORMAL]: 5000,
    [ToastDuration.LONG]: 8000,
    [ToastDuration.FOREVER]: 0,
};

export { TOAST_DURATION_TO_MS, TOAST_TYPE_TO_COLOR_AND_SVG, ToastDuration, ToastType };
//# sourceMappingURL=constants.js.map
